import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { shopManagerApi } from 'configs';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@material-ui/core';
import { BackdropCircular } from 'components';
import { addTouchMDLog } from 'redux/actions/sync_logs';
import { getTouchMDSyncLogsAPI } from 'api/syncLogs';
import useStyles from './styles';
import LogTableRow from './LogTableRow';


const TouchMDSyncLogs = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const {touchMDSyncLogs = [], touchMDTotalCount, loadingTouchMDLogs} = useSelector((state: IReduxState) => state.sync_logs);

  useEffect(() => {
    getTouchMDSyncLogsAPI({dispatch, currentPage, rowsPerPage});
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    const eventSource = new EventSource(`${shopManagerApi}/touchmd/api/sync-logs-sse`, { withCredentials: true });

    eventSource.onmessage = function (event) {
      const data = JSON.parse(event.data);

      if (data.log) {
        dispatch(addTouchMDLog(data));
      }
    };
    eventSource.onerror = function () {
      eventSource.close();
    };

    return () => {
      eventSource.close();
    };
  }, []);

  const handleChangePage = (_, newPage) => {
    setCurrentPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  return (
    <div>
      <TableContainer className={classes.table}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className="pl-sm-24 w-130 font-bold">Event Name</TableCell>
              <TableCell className="px-0 font-bold" align="center">Started At</TableCell>
              <TableCell className="px-0 font-bold" align="center">Ended At</TableCell>
              <TableCell className="px-0 font-bold" align="center">Status</TableCell>
              <TableCell className="px-0 font-bold" align="center">Number of Records</TableCell>
              <TableCell className="px-0 w-100 font-bold" align="center">Error</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!!touchMDSyncLogs.length ?
              touchMDSyncLogs.map((syncLog) => (
                <LogTableRow
                  syncLog={syncLog}
                  key={syncLog.id}
                />
              ))
              :
              <TableRow>
                <TableCell colSpan={12}>
                  <p className="text-center text-muted">No logs created yet</p>
                </TableCell>
              </TableRow>
            }
          </TableBody>
        </Table>
      </TableContainer>
      {!!touchMDSyncLogs.length &&
        <TablePagination
          rowsPerPageOptions={[10, 20, 40, 80, 100]}
          component="div"
          className={classes.paginationContainer}
          count={touchMDTotalCount}
          rowsPerPage={rowsPerPage}
          page={currentPage - 1}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      }
      <BackdropCircular loading={loadingTouchMDLogs} />
    </div>
  );
};

export default TouchMDSyncLogs;
